/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical, faRotate } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import GroupsIcon from "../../../assets/icons/groups.svg2";
import HelpButton from "../../HelpContent/HelpButton";

export default function GroupsWidget() {
  return (
    <div className="position-relative px-2 d-flex flex-column h-100">
      <div className="d-flex p-3 pb-1 align-items-center">
        <GroupsIcon width={20} className="white opacity-50" />
          <Link className="btn p-0 text-white" to="/assets/events">
        <h6 className="m-0 mx-2 small fw-bold">
            EVENTS
        </h6>
          </Link>
        <button
          className="btn p-0 text-white ms-2"
          onClick={() => window.location.reload()}
          title="Refresh events data"
        >
          <FontAwesomeIcon icon={faRotate} className="opacity-50" />
        </button>
        <HelpButton helpKey="widget-events" iconClassName="white" />{" "}
        <FontAwesomeIcon
          icon={faGripVertical}
          className="ms-4 opacity-50 widget-header"
        />
      </div>
      <div className=" overflow-auto">
        <hr className="m-1" />
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 opacity-50">Events by priority</span>
          <h3 className="fw-bold m-0 p-1">{6}</h3>
        </div>
        <hr className="m-1" />
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">Low priority</span>
          <h3 className="fw-bold m-0 p-1 small">{2}</h3>
        </div>
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">Medium priority</span>
          <h3 className="fw-bold m-0 p-1 small">{2}</h3>
        </div>{" "}
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">High priority</span>
          <h3 className="fw-bold m-0 p-1 small">{2}</h3>
        </div>
        <hr className="m-1" />
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 opacity-50">Events by status</span>
          <h3 className="fw-bold m-0 p-1">{6}</h3>
        </div>
        <hr className="m-1" />
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">Published</span>
          <h3 className="fw-bold m-0 p-1 small">{2}</h3>
        </div>
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">Draft</span>
          <h3 className="fw-bold m-0 p-1 small">{2}</h3>
        </div>{" "}
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">Archived</span>
          <h3 className="fw-bold m-0 p-1 small">{2}</h3>
        </div>
        {[
          {
            label: <div className="opacity-50">Average event duration</div>,
            value: <div>20 mins</div>,
          },
          {
            label: (
              <div className="opacity-50">Start and running time of events</div>
            ),
            value: <div>{12.2}</div>,
          },
        ].map((r, i) => (
          <React.Fragment key={i}>
            <hr className="m-1" />
            <div className="d-flex justify-content-between px-3">
              <span className="fw-bold p-1">{r.label}</span>
              <h3 className="fw-bold m-0 p-1">{r.value}</h3>
            </div>
          </React.Fragment>
        ))}
        <hr className="m-1" />
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 opacity-50">
            Comms type used for events
          </span>
          <h3 className="fw-bold m-0 p-1">{6}</h3>
        </div>
        <hr className="m-1" />
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">Sms</span>
          <h3 className="fw-bold m-0 p-1 small">{2}</h3>
        </div>
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">Email</span>
          <h3 className="fw-bold m-0 p-1 small">{2}</h3>
        </div>{" "}
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">Voice</span>
          <h3 className="fw-bold m-0 p-1 small">{2}</h3>
        </div>
      </div>
      <div className="flex-grow-1" />
    </div>
  );
}
